import React, { useEffect, useState } from 'react';
import styles from './procedimentos_deialeticia1995.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaWhatsapp, FaTimes } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5517988106722';

const procedimentos = [
    { titulo: 'Bronze artificial', imagens: [require('./src/8.png'), require('./src/9.png')] },
    { titulo: 'Brow lamination', imagens: [require('./src/1.png')] },
    { titulo: 'Designer simples de sobrancelhas', imagens: [require('./src/2.png')] },
    { titulo: 'Extensao de cílios - Volume Brasileiro', imagens: [require('./src/3.png')] },
    { titulo: 'Extensao de cílios - Volumão Brasileiro', imagens: [require('./src/4.png')] },
    { titulo: 'Micropgmentação labial', imagens: [require('./src/5.png')] },
    { titulo: 'Maquiagem', imagens: [require('./src/6.png')] },
    { titulo: 'Sobrancelha fio a fio', imagens: [require('./src/7.png')] }
];

interface CarouselCardProps {
    titulo: string;
    imagens: string[];
    onImageClick: (img: string) => void;
}

const CarouselCard: React.FC<CarouselCardProps> = ({ titulo, imagens, onImageClick }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const hasMultipleImages = imagens.length > 1;

    const prevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    };

    const nextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));
    };

    const handleWhatsAppClick = () => {
        const message = encodeURIComponent(`Olá! Gostaria de saber mais sobre o procedimento: ${titulo}`);
        window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
    };

    return (
        <div className={styles.card}>
            <div className={styles.carouselContainer} onClick={() => onImageClick(imagens[currentIndex])}>
                <img src={imagens[currentIndex]} alt={titulo} />
                {hasMultipleImages && (
                    <>
                        <button className={styles.carouselBtn + ' ' + styles.prevBtn} onClick={prevImage}>
                            <FaChevronLeft />
                        </button>
                        <button className={styles.carouselBtn + ' ' + styles.nextBtn} onClick={nextImage}>
                            <FaChevronRight />
                        </button>
                        <div className={styles.indicators}>
                            {imagens.map((_, idx) => (
                                <span
                                    key={idx}
                                    className={`${styles.dot} ${idx === currentIndex ? styles.active : ''}`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setCurrentIndex(idx);
                                    }}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
            <h3>{titulo}</h3>
            <button className={styles.whatsappBtn} onClick={handleWhatsAppClick}>
                <FaWhatsapp /> Agendar
            </button>
        </div>
    );
};

interface ImageModalProps {
    imageSrc: string;
    onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ imageSrc, onClose }) => {
    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEsc);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = 'auto';
        };
    }, [onClose]);

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <button className={styles.modalClose} onClick={onClose}>
                <FaTimes />
            </button>
            <img src={imageSrc} alt="Imagem expandida" onClick={(e) => e.stopPropagation()} />
        </div>
    );
};

const Procedimentos_deialeticia1995: React.FC = () => {
    const [expandedImage, setExpandedImage] = useState<string | null>(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.procedimentos_deialeticia1995}>
            <div className={styles.header}>
                <Link to="/deialeticia1995" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h2>Procedimentos</h2>
            </div>
            <div className={styles.grid}>
                {procedimentos.map((item, index) => (
                    <CarouselCard
                        key={index}
                        titulo={item.titulo}
                        imagens={item.imagens}
                        onImageClick={(img) => setExpandedImage(img)}
                    />
                ))}
            </div>

            {expandedImage && (
                <ImageModal imageSrc={expandedImage} onClose={() => setExpandedImage(null)} />
            )}
        </div>
    );
};

export default Procedimentos_deialeticia1995;
